import { Suspense, useEffect, useRef, useState, type ReactNode } from 'react';

const visited = new Set<string>();

/** Load lower-page widgets before they enter view and retain them when returning. */
export function DeferredHomeContent({ cacheKey, children }: { cacheKey: string; children: ReactNode }) {
  const marker = useRef<HTMLDivElement>(null);
  const [ready, setReady] = useState(() => typeof window !== 'undefined' && (visited.has(cacheKey) || window.location.hash === '#' + cacheKey));
  useEffect(() => {
    if (ready) { visited.add(cacheKey); return; }
    const element = marker.current;
    if (!element) return;
    if (typeof IntersectionObserver === 'undefined') { setReady(true); return; }
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { visited.add(cacheKey); setReady(true); observer.disconnect(); }
    }, { rootMargin: '800px' });
    observer.observe(element);
    return () => observer.disconnect();
  }, [cacheKey, ready]);
  return <div ref={marker} data-deferred-home={cacheKey} style={{ minHeight: 1 }}>
    {ready && <Suspense fallback={null}>{children}</Suspense>}
  </div>;
}
